import { useI18n } from '@ecom/i18n';
import { Badge } from '@ecom/ui-kit';
import { type ReactElement } from 'react';

/** Variant-improvements lot — mirrors `ProductStatusBadge`'s own pattern for the new boolean `isActive` field. */
export function VariantStatusBadge({ isActive }: { isActive: boolean }): ReactElement {
  const { t } = useI18n();
  return (
    <Badge tone={isActive ? 'good' : 'neutral'}>
      {isActive
        ? t('merchant.products.variants.status.active')
        : t('merchant.products.variants.status.inactive')}
    </Badge>
  );
}
